class GiftDispatcher extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.gifts = this.querySelectorAll('input[type="hidden"]');
        if(window.deployer_state.enable_gift_dispatcher === true) {
            this.listenEvents();
        }
    }

    disconnectedCallback() {
        this.removeEvents();
    }

    listenEvents() {
        document.addEventListener('cart:updated', (event) => {
            this.checkAndAddGifts(event.detail.cart);
        });
    }

    removeEvents() {}

    async getCart() {
        return fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    async checkAndAddGifts(cart) {
        for (const gift of this.gifts) {
            const variantId = parseInt(gift.dataset.variantId);
            const amountType = gift.dataset.amountType;
            const amountUnit = parseFloat(gift.dataset.amountUnit);
            const isSufficient = this.isTierSufficient(cart, amountType, amountUnit);
            const isAvailable  = gift.dataset.available === 'true';

            if(!isSufficient) {
                console.log(`Tier is not sufficient for adding variant gift`);
                return;
            }

            if(!isAvailable) {
                console.log(`Variant ${variantId} is not available`);
                return;
            }

            if(this.isAlreadyOnCart(cart, variantId)) {
                console.log(`Variant ${variantId} is already on cart`);
                return;
            }

            this.addToCartGift(variantId);
        }
    }

    isTierSufficient(cart, amountType, amountUnit) {
        switch (amountType) {
            case 'amount':
                return this.isAmountSufficient(cart, amountUnit);
            default:
                return false;
        }
    }

    isAmountSufficient(cart, amountUnit) {
        const cartTotal = cart.items_subtotal_price;
        return cartTotal >= amountUnit;
    }
    

    async addToCartGift(variantId) {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                    },
                ],
            }),
        }).then((response) => {
            let cartContent = response.json();
            this.updateCart(cartContent);
        }).catch((error) => {
            console.error('Error adding gift to cart:', error);
        });
    }

    isAlreadyOnCart(cart, variantId) {
        return cart.items.some((item) => item.variant_id == variantId);
    }

    updateCart(cartContent) {
        /* Dispatch the theme event */
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
           bubbles: true,
           detail: {
               cart: cartContent,
            },
        }));   
    }
}

customElements.define('gift-dispatcher', GiftDispatcher);
